// extracted by mini-css-extract-plugin
export var content = "_qd-1";
export var fullScreen = "_qd-0";